var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":_vm.title,"visible":_vm.visible,"confirm-loading":_vm.confirmLoading},on:{"cancel":_vm.handleCancel,"ok":_vm.handleConfirm}},[_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }